import {
  getInvitations as getInvitationsApi,
  getInvitation as getInvitationApi,
  deleteInvitation,
  resendInvitation as resendInvitationApi,
  changeInvitationAccountType as changeInvitationAccountTypeApi
} from 'common/services/invitations.service';

import {
  destroyInvitationSucceed,
  fetchInvitationsSucceed,
  reinviteSucceed,
  invitationChangeAccountTypeSucceeded
} from '../actions/invitations';

export const getInvitations =
  (options = {}) =>
  async dispatch => {
    try {
      const invitations = await getInvitationsApi(options);
      dispatch(fetchInvitationsSucceed(invitations));
    } catch (e) {}
  };

export const getInvitation = id => async () => {
  try {
    return getInvitationApi(id);
  } catch (e) {
    throw e;
  }
};

export const destroyInvitation = id => async dispatch => {
  try {
    await deleteInvitation(id);
    dispatch(destroyInvitationSucceed({ id }));
    return null;
  } catch (e) {
    throw e;
  }
};

export const resendInvitation = id => async dispatch => {
  try {
    const invitation = await resendInvitationApi(id);
    dispatch(reinviteSucceed(invitation));
    return invitation;
  } catch (e) {
    throw e;
  }
};

export const changeInvitationAccountType =
  ({ id, type_id }) =>
  async dispatch => {
    try {
      const invitation = await changeInvitationAccountTypeApi(id, type_id);
      dispatch(invitationChangeAccountTypeSucceeded(invitation));
      return invitation;
    } catch (e) {
      throw e;
    }
  };
